export const CART_STATUS = {
  PENDING: 'Pending',
  COMPLETED: 'Completed'
};

export const CART_CHANNELS = {
  WEB: 'Web',
  CARD: 'Card'
};
